import Marionette from 'backbone.marionette';
import Backbone from 'backbone';

// Internal Dependencies - screens/views/templates
import specialistRecordsModalView  from '../../../../templates/CCM/PatientList/specialistRecordsModalView';
import SpecialistRecordsCompositeView from './SpecialistRecordsCompositeView'

// Internal Dependencies - models/collections

export default Marionette.LayoutView.extend({

	regions: {
		recordsList: '.record-list-container',
	},

	events: {
		'click .modal-close': 'closeModal',
		'click .download-all-records': 'downloadAll',
	},

	initialize: function( options ) {
		this.channel = Backbone.Radio.channel( 'AppChannel' );
		this.app = this.channel.request( 'app' );
		this.controller = this.app.ccm_controller;
		this.collection = new Backbone.Collection();
		this.listenTo( this.channel, 'close:modal', this.closeModal );
		this.listenTo( this.channel, 'trigger:records_modal', this.showChildren );
	},

	getTemplate: function() {
		return specialistRecordsModalView( this.model );
	},

	showChildren: function() {
		this.showChildView( 'recordsList', new SpecialistRecordsCompositeView( {collection: this.collection, model: this.model} ) );
	},

	downloadAll: function() {
		this.controller.getAllPatientRecords( this.model.get( 'id' ) );
	},

	closeModal: function( e ) {
		e && e.preventDefault();
		$( '#specialistRecordsModal' ).closeModal();
		this.destroy();
	},

});
